<template>
  <div class="col-md-6 col-lg-8 px-5 py-4">
    <div class="p-2">
      <slot />
    </div>
  </div>
</template>

<script>
export default {

};
</script>

<style>

</style>
